import {
  ContentTag,
  isComparisonActive,
  isInPlaceEditingActive,
  provideComponent,
  useData
} from "scrivito"

import { DataErrorEditorNote } from "widgets/scrivito-data/DataErrorEditorNote"

import { DataEmptyWidget } from "./DataEmptyWidgetClass"

provideComponent(
  DataEmptyWidget,
  ({ widget }) => {
    const dataScope = useData()

    let containsData
    try {
      containsData = dataScope.containsData()
    } catch (error) {
      return <DataErrorEditorNote error={error} />
    }

    if (containsData && !isInPlaceEditingActive() && !isComparisonActive()) {
      return null
    }

    return (
      <ContentTag
        content={widget}
        attribute="content"
        className={containsData ? "opacity-60" : null}
        dataContext={dataScope}
      />
    )
  },
  { loading: () => null }
)
